import type { CSSProperties } from 'react';
import {
    getFlipStyle,
    getImageMaskStyle,
    getImageStyle,
    getImageTransformInfo,
    getInnerStyle,
} from '@/layers/image-layer/utils/layer';
import { base64Kit } from '@/utils/base64-kit';
import { IImageLayerProps, ILayerProps } from '@/version-types';

export interface CropViewModel {
    flipStyle: CSSProperties;
    imageInnerStyle: CSSProperties;
    imgStyle: CSSProperties;
    maskStyle: CSSProperties;
    url: string;
    naturalWidth: number;
    naturalHeight: number;
    moveWidth: number;
    moveHeight: number;
}

export const computeCropViewModel = (layer: ILayerProps, stageScale: number): CropViewModel => {
    const {
        maskURL,
        imageTransform: { flipH, flipV, scale: imageScale, rotate },
        naturalWidth,
        naturalHeight,
        url,
        minimumMask,
    } = layer.data as IImageLayerProps;
    // 消除结果可能仍是缓存 ID，DOM 展示前需解析为可加载的图片地址
    const imageUrl = base64Kit.getLocalUrl(url);
    const maskUrl = maskURL ? base64Kit.getLocalUrl(maskURL) : imageUrl;
    const { originImgWidth, originImgHeight, offsetX, offsetY } = getImageTransformInfo(layer);

    const displayWidth = originImgWidth * imageScale * stageScale;
    const displayHeight = originImgHeight * imageScale * stageScale;
    const frameWidth = layer.width * stageScale;
    const frameHeight = layer.height * stageScale;
    const offsetXDisplay = offsetX * stageScale;
    const offsetYDisplay = offsetY * stageScale;

    const flipStyle = getFlipStyle(flipH, flipV);
    const imageInnerStyle = getInnerStyle(
        displayWidth,
        displayHeight,
        offsetXDisplay,
        offsetYDisplay,
        rotate,
        imageScale,
        maskURL,
        frameWidth,
        frameHeight,
    );

    imageInnerStyle.transform = `translate(${offsetXDisplay + ((layer.width - originImgWidth * imageScale) * stageScale) / 2}px, ${offsetYDisplay + ((layer.height - originImgHeight * imageScale) * stageScale) / 2}px) rotate(${rotate}deg) scale(1)`;

    return {
        flipStyle,
        imageInnerStyle,
        imgStyle: getImageStyle(displayWidth, displayHeight),
        maskStyle: {
            ...getImageMaskStyle(maskUrl, minimumMask),
            maskSize: maskURL ? 'contain' : '',
        },
        url: imageUrl,
        naturalWidth,
        naturalHeight,
        moveWidth: displayWidth,
        moveHeight: displayHeight,
    };
};
